import { Fragment, useState, useRef } from 'react'
import { Form, StrictTextAreaProps } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'

interface TextAreaProps extends StrictTextAreaProps {
  autoFocus?: boolean
  placeholder?: string
  disabled?: boolean
  value: number | string
  sensitive?: boolean
  icon?: { name: string; color?: string }
}

const TextArea = ({
  disabled,
  value,
  sensitive,
  icon,
  ...rest
}: TextAreaProps) => {
  const [visible, setVisible] = useState(false)
  const inputEl = useRef(null)

  const { t } = useTranslation()

  const Input = (
    <Form.TextArea
      {...rest}
      value={
        sensitive && !visible
          ? Array(String(value || '').length + 1).join('*')
          : value
      }
      icon={sensitive && !visible ? { name: 'eye', color: '#0398cc' } : icon}
      disabled={(sensitive && !visible) || disabled}>
      <input data-lpignore="true" ref={inputEl} />
    </Form.TextArea>
  )

  if (sensitive && !visible) {
    return (
      <div
        className="sensitive"
        title={t('Edit content')}
        onClick={() => {
          setVisible(true)
        }}>
        {Input}
      </div>
    )
  }

  return <Fragment>{Input}</Fragment>
}

export default TextArea
